import { Deserializable } from './deserializable.model';
export class PubkeyData implements Deserializable<PubkeyData> {
  public share_id?: number;
  public share_sequence?: number;
  public id: number;
  public key: string;

  public deserialize(params: any): PubkeyData {
    Object.assign(this, params);
    return this;
  }
}
